import {
  jb_breadcrumbs_css_default
} from "./chunk.QFIC4UG7.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.3FKBYJ4V.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  o
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-breadcrumbs/jb-breadcrumbs.ts
var JbBreadcrumbs = class extends r {
  firstUpdated() {
    if (!this.removeLastDuplicate || this._items.length < 2) return;
    if (this._items[this._items.length - 1].text === this._items[this._items.length - 2].text) {
      this._items[this._items.length - 2].remove();
    }
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "breadcrumb",
      interaction_text: e.detail.linkTag.innerText
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <div @jb-link:clicked=${this._tracking}>
        <slot name="backlink"></slot>
        <div role="list">
          <slot name="items"></slot>
        </div>
      </div>
    `;
  }
};
JbBreadcrumbs.styles = [reset_css_default, jb_breadcrumbs_css_default];
__decorateClass([
  n({ type: Boolean })
], JbBreadcrumbs.prototype, "removeLastDuplicate", 2);
__decorateClass([
  o({ slot: "items" })
], JbBreadcrumbs.prototype, "_items", 2);
JbBreadcrumbs = __decorateClass([
  customElement("jb-breadcrumbs")
], JbBreadcrumbs);

export {
  JbBreadcrumbs
};
